/**
 * @file IconCheckbox Icon
 * @author Auto Generated by @polyv/icons-cli
 */

import { IconBuilder } from '@polyv/icons-vue/icon-builder';

export default IconBuilder(
  'icon-checkbox',
  (data) => `
<svg width="${data.size}" height="${data.size}" viewBox="0 0 48 48">
  <g
    fill="none"
    fill-rule="evenodd"
    stroke="none"
    stroke-width="${data.strokeWidth * 0.6666666666666666}"
  >
    <g transform="translate(-1152,-1840)">
      <g transform="translate(465.3333333333333,320)">
        <g transform="translate(686.6666666666666,1520)">
          <rect
            width="48"
            height="48"
            x="0"
            y="0"
            fill="#366BEE"
            rx="5.333333333333333"
          />
          <polyline
            stroke="${data.colorDesc[2]}"
            stroke-linecap="${data.strokeLinecap}"
            stroke-linejoin="${data.strokeLinejoin}"
            stroke-width="${data.strokeWidth * 0.9333333333333332}"
            points="12.07 24 21.33 33.26 37.33 17.26"
          />
        </g>
      </g>
    </g>
  </g>
</svg>
`
);
